module.exports = "<div class=\"inhalt\">\n  <h1 class=\"oben\">Surfschule</h1><br />\n  <iFrame class=\"site\" src=\"http://www.surfschule-wiesensee.de/test/assets/includes/schule.php\" frameborder=\"0\" scrolling=\"no\"></iFrame>\n  <app-footer></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/surfschule/surfschule.component.html
// module id = ../../../../../src/app/surfschule/surfschule.component.html
// module chunks = main